import React from 'react';

interface LogoProps {
  className?: string;
  showSubtitle?: boolean;
  variant?: 'red' | 'white';
}

export function Logo({ className = '', showSubtitle = false, variant = 'red' }: LogoProps) {
  const logoUrl = variant === 'white'
    ? "https://guurrickmxxnxobbsjbp.supabase.co/storage/v1/object/public/Images//BizComfort%20white%20no%20bg.png"
    : "https://guurrickmxxnxobbsjbp.supabase.co/storage/v1/object/public/Images//BizComfort%20red%20no%20bg.png";

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <div className="h-11 relative">
        <img 
          src={logoUrl}
          alt="BizComfort" 
          className="h-full w-auto object-contain"
        />
      </div>
      {showSubtitle && (
        <span className={`font-bold text-sm mt-2 ${variant === 'white' ? 'text-white/90' : 'text-gray-600'}`}>
          Jouw link naar techniek
        </span>
      )}
    </div>
  );
}